import { FinancialSituationOwner } from '../../../../types';
export var list = [
    FinancialSituationOwner.NO,
    FinancialSituationOwner.IS_OWNER_WITH_CREDIT,
    FinancialSituationOwner.IS_OWNER,
];
